"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _stencilReactDesc = require("@amzn/stencil-react-desc");

var _utils = require("../../../utils");

var _Input = _interopRequireDefault(require("../Input"));

var _propTypes = require("../propTypes");

var _CurrencyInsetElement = require("./CurrencyInsetElement");

var _constants = require("./constants");

var _utils2 = require("./utils");

var _core = require("@emotion/core");

var _excluded = ["code", "locale", "value", "onChange", "defaultValue", "disabled"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var CurrencyInputWithoutDocs = /*#__PURE__*/_react.default.forwardRef(function (_ref, ref) {
  var code = _ref.code,
      locale = _ref.locale,
      value = _ref.value,
      onChange = _ref.onChange,
      defaultValue = _ref.defaultValue,
      disabled = _ref.disabled,
      forwardedProps = (0, _objectWithoutProperties2.default)(_ref, _excluded);

  var _useState = (0, _react.useState)((0, _utils2.formatToCurrency)(value || defaultValue, locale)),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      stateValue = _useState2[0],
      setStateValue = _useState2[1]; // The value prop takes priority over the internal state value


  (0, _react.useMemo)(function () {
    if (value !== undefined && value !== stateValue) {
      setStateValue((0, _utils2.formatToCurrency)(value, locale));
    }
  }, [value, locale, stateValue]);

  var handleChange = function handleChange(e) {
    var oldValue = e.target.value;
    var formattedValue = (0, _utils2.formatToCurrency)(oldValue, locale); // Manage caret position

    if (stateValue) {
      var element = e.target;
      var caret = element.selectionStart;
      var separatorLengthDifference = formattedValue.replace(/[0-9]/g, '').length - stateValue.replace(/[0-9]/g, '').length;
      var numberLengthDifference = (0, _utils2.stripNonNumericChars)(formattedValue).length - (0, _utils2.stripNonNumericChars)(stateValue).length; // Shift caret forwards when a separator is inserted
      // to keep it in the same position.
      // Do that for any difference > 0 to support copy and pasting

      if (separatorLengthDifference > 0) {
        caret += separatorLengthDifference;
      } // Shift caret backwards by one when a separator is removed
      // Checks for number length difference to support deleting multiple chars
      // Checks for caret !== 0 to avoid wrapping


      if (separatorLengthDifference === -1 && numberLengthDifference === -1 && caret !== 0) {
        caret -= 1;
      } // If the value didn't change, leave the caret in the initial place
      // This can happen when user tries to insert an invalid character
      // Check for length difference to not reset when chars are removed


      if (stateValue === formattedValue && oldValue.length > formattedValue.length) {
        caret = element.selectionStart - 1;
      }

      window.requestAnimationFrame(function () {
        element.selectionStart = caret;
        element.selectionEnd = caret;
      });
    } // Only set internal value when the value prop is not passed
    // as the prop takes priority


    value === undefined && setStateValue(formattedValue);

    if (!!onChange && stateValue !== formattedValue) {
      onChange(e, formattedValue, parseInt((0, _utils2.stripNonNumericChars)(formattedValue)));
    }
  };

  var leadingConfig = {
    inset: disabled ? 12 : 0,
    width: _constants.CURRENCY_CODE_CONTAINER_WIDTH + 8,
    element: (0, _core.jsx)(_CurrencyInsetElement.CurrencyInsetElement, (0, _extends2.default)({}, (0, _utils.omitDataProps)(forwardedProps), {
      disabled: disabled
    }), code)
  };
  return (0, _core.jsx)(_Input.default, (0, _extends2.default)({}, forwardedProps, {
    insetElementLeading: leadingConfig,
    value: stateValue,
    onChange: handleChange,
    disabled: disabled,
    ref: ref
  }));
});

var CurrencyInputWithDocs = (0, _stencilReactDesc.describe)(CurrencyInputWithoutDocs).description('Input element that automatically formats numbers as a currency.');
CurrencyInputWithDocs.propTypes = _objectSpread(_objectSpread({}, _propTypes.inputBasePropTypes), {}, {
  code: _stencilReactDesc.PropTypes.string.description('The currency code, e.g. "USD", "GBP".'),
  locale: _stencilReactDesc.PropTypes.string.description('Locale that will be used to format the currency. Should be an Intl-compatible string, such as "en-US".'),
  onChange: _stencilReactDesc.PropTypes.func.description('Callback function that will be called when the input is changed. It passes both the currency formatted string, and the number.').format('(e: React.ChangeEvent<HTMLInputElement>, formattedValue: string, unformattedValue: number) => void')
});
var CurrencyInput = (0, _utils.withTestAttributes)({
  component: 'StencilCurrencyInput'
})(CurrencyInputWithDocs);
CurrencyInput.displayName = 'CurrencyInput';
var _default = CurrencyInput;
exports.default = _default;